var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BigHeader',{attrs:{"title":"Always up to date","subtitle":"Follow the latest LISA news","icon1":"","line1":"","icon2":"","line2":"","icon3":"","line3":""}}),_c('div',{staticStyle:{"height":"600px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }